/*
 * @Author: wjl
 * @Date: 2020-04-21 10:03:58
 * @LastEditors: wjl
 * @LastEditTime: 2020-09-01 09:05:59
 * @FilePath: \appOfficial\src\main.js
 */

import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import router from "./router";
import VueI18n from "vue-i18n";
// import VConsole from "vconsole";

Vue.use(VueI18n, axios);

// Vue.config.productionTip = false;
// const vConsole = new VConsole();

const i18n = new VueI18n({
  locale:
    window.localStorage.getItem("user_lang") == null
      ? "ch"
      : window.localStorage.getItem("user_lang"), // 语言标识
  messages: {
    ch: require("./utils/ch"),
    en: require("./utils/en"),
    fan: require("./utils/fan"),
  },
});

new Vue({
  router,
  i18n,
  // vConsole,
  render: (h) => h(App),
}).$mount("#app");
